import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("gofret_cookies");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => { localStorage.setItem("gofret_cookies", "accepted"); setVisible(false); };
  const refuse = () => { localStorage.setItem("gofret_cookies", "refused"); setVisible(false); };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-2xl p-4 md:p-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4">
        <Shield size={24} className="text-gofret-orange flex-shrink-0" />
        <p className="text-sm text-slate-600 flex-1">
          Nous utilisons des cookies pour ameliorer votre experience sur notre site. En continuant votre navigation, vous acceptez l'utilisation de cookies conformement a notre{" "}
          <a href="/politique-confidentialite" className="text-gofret-orange underline">politique de confidentialite</a>.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <Button data-testid="cookie-refuse" variant="outline" size="sm" onClick={refuse}>Refuser</Button>
          <Button data-testid="cookie-accept" size="sm" className="bg-gofret-orange hover:bg-gofret-orange-dark text-white" onClick={accept}>Accepter</Button>
        </div>
      </div>
    </div>
  );
}
